'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _injectable = require('./injectable');

var _injectable2 = _interopRequireDefault(_injectable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Provider = function (_Injectable) {
  _inherits(Provider, _Injectable);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Provider).apply(this, arguments));
  }

  return Provider;
}(_injectable2.default);

exports.default = Provider;
//# sourceMappingURL=provider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-ecmascript/dist/module-helpers/provider.js
// module id = 631
// module chunks = 0